// extracted by css-extract-rspack-plugin
export default {"heading":"heading-jSnjiO","article-list":"article-list-eyGf3I","articleList":"article-list-eyGf3I"};